import { LinkText } from "@sb1/ffe-core-react";
import classNames from "classnames";
import type { FC, MouseEvent, PropsWithChildren } from "react";
import { externNavigering, fullUrl, type LinkProps } from "./Link";
import { useNavigate } from "~/shared/hooks/use-navigate";
import mbc from "~/shared/functions/mbc";

const PDF_TITLE_REGEX = /(\w|-|\.)+(?=\.pdf)/gi;

const MbcLink: FC<PropsWithChildren<LinkProps>> = ({
	to,
	className,
	onClick,
	onReturn,
	type,
	navigationBarTitle,
	presentationStyle,
	closeEntireExternalLayer,
	authenticationUpgradeRequired,
	state,
	children,
}) => {
	const navigate = useNavigate();

	const _onClick = (event?: MouseEvent<HTMLAnchorElement>) => {
		onClick?.(event);
		if (type === "pdf") {
			const pdfTitle = to.match(PDF_TITLE_REGEX) || ["sparebank1-forsikring-pdf"];
			mbc.openPdf(fullUrl(to), pdfTitle[0]);
		} else if (externNavigering(to)) {
			mbc.openExternalWebTab(to);
		} else {
			navigate(to, {
				navigationBarTitle,
				presentationStyle: presentationStyle ? presentationStyle : "INTERNAL",
				closeEntireExternalLayer,
				onReturn,
				state,
				authenticationUpgradeRequired: authenticationUpgradeRequired,
			});
		}
	};

	return (
		<LinkText onClick={_onClick} className={classNames(className)}>
			{children}
		</LinkText>
	);
};
export default MbcLink;
